import EntitiesPage from "./EntitiesPage";

// Vendors = who you pay or owe: receipts (paid) + bills (due). Money out.
export default function Vendors() {
  return (
    <EntitiesPage
      kind="vendor"
      title="Vendors"
      subtitle="Who you spend with, rolled up across every receipt and bill."
      entityLabel="Vendor"
      amountLabel="Total spent"
      basePath="/app/vendors"
    />
  );
}
